import { useEffect, useMemo } from 'react';
import type BoltMetaArgs from 'types/BoltMetaArgs';
import type { Article } from 'types/capi/article';

import ArticleV2 from '~/components/article/ArticleV2';
import ArticleViewEvent from '~/events/ArticleViewEvent';
import usePageData from '~/hooks/usePageData';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';
import useViewEvent from '~/hooks/useViewEvent';
import { getCanonicalUrl } from '~/utils/canonicalUrl';
import seo from '~/utils/seo';

import ArticleV1Component from './legacy-article/ArticleV1';

function getArticleViewProperties(article: Article) {
  if (!('id' in article)) return undefined;

  return { article_id: article.id };
}

export default function NewsRoute() {
  const data = usePageData<Article>();
  const user = useUser();
  const { clientIp, isBot } = useRootData();

  useViewEvent({
    viewProperties: useMemo(() => getArticleViewProperties(data), [data]),
    viewType: 'article'
  });

  useEffect(() => {
    new ArticleViewEvent({
      article: data,
      clientIp: clientIp ?? undefined,
      isBot,
      user
    }).send();
  }, [clientIp, data, isBot, user]);

  return data.template === 'v2' ? <ArticleV2 /> : <ArticleV1Component />;
}

type LoaderData = {
  pageData: Article;
};

export const meta = (metaArgs: BoltMetaArgs<LoaderData>) => {
  const { data } = metaArgs;

  if (!data) return [];

  const canonicalUrl = getCanonicalUrl(metaArgs, data.pageData.canonical_url);

  return seo.formatForMeta(canonicalUrl, data.pageData.seo);
};

export { loader } from './legacy-article/loader.server';
